import React from 'react';
import { Col, Row, Form } from 'react-bootstrap';
import Skeleton from '../../common/skeleton';

const PasswordSettingsSkeleton = () => {
  return (
    <Form>
      <Row>
        <Col>
          <Form.Group controlId="allowUnlockDisabledLogin" className="mb-4">
            <div className="form-check d-flex">
              <Skeleton
                count={1}
                width={20}
                height={20}
                containerClassName={'form-label mr-3'}
              />
              <Skeleton
                count={1}
                width={190}
                containerClassName={'form-label'}
              />
            </div>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm={4}>
          <Form.Group controlId="passwordMinLength" className="mb-4">
            <Form.Label for="MinLength" className="m-0">
              <Skeleton
                count={1}
                width={165}
                height={12}
                containerClassName={'m-0 form-label'}
              />
            </Form.Label>
            <Skeleton count={1} height={38} containerClassName={''} />
          </Form.Group>
        </Col>
        <Col sm={4}>
          <Form.Group controlId="passwordMaxLength" className="mb-4">
            <Form.Label for="MaxLength" className="m-0">
              <Skeleton
                count={1}
                width={165}
                height={12}
                containerClassName={'m-0 form-label'}
              />
            </Form.Label>
            <Skeleton count={1} height={38} containerClassName={''} />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm={4}>
          <Form.Group controlId="passwordMinLength" className="mb-4">
            <Form.Label for="MinLength" className="m-0">
              <Skeleton
                count={1}
                width={195}
                height={12}
                containerClassName={'m-0 form-label'}
              />
            </Form.Label>
            <Skeleton count={1} height={38} containerClassName={''} />
          </Form.Group>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col sm={12}>
          <h4 className="mt-4 mb-4">Password Rules</h4>
        </Col>
        <Col>
          <Form.Group controlId="numberOfUpperCase" className="mb-4">
            <div className="form-check d-flex">
              <Skeleton
                count={1}
                width={20}
                height={20}
                containerClassName={'form-label mr-3'}
              />
              <Skeleton
                count={1}
                width={230}
                containerClassName={'form-label'}
              />
            </div>
          </Form.Group>
          <Form.Group controlId="NumericsReqd" className="mb-4">
            <div className="form-check d-flex">
              <Skeleton
                count={1}
                width={20}
                height={20}
                containerClassName={'form-label mr-3'}
              />
              <Skeleton
                count={1}
                width={150}
                containerClassName={'form-label'}
              />
            </div>
          </Form.Group>
          <Form.Group controlId="CharactersReqd" className="mb-4">
            <div className="form-check d-flex">
              <Skeleton
                count={1}
                width={20}
                height={20}
                containerClassName={'form-label mr-3'}
              />
              <Skeleton
                count={1}
                width={180}
                containerClassName={'form-label'}
              />
            </div>
          </Form.Group>
        </Col>
      </Row>
    </Form>
  );
};

export default PasswordSettingsSkeleton;
